let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hl2oi"), load("9dfxa")]).then(() => parcelRequire('cOAGo'));